module.exports = ".circle-container {\n  width: 3rem;\n  height: 3rem;\n  background-color: blue;\n  border-radius: 50%; }\n"